import React, { useState, useEffect, useMemo } from 'react'
import { useNavigate } from 'react-router-dom'
import axios from 'axios'
import { formatDateFit } from '../buyer/BuyerRequestDetails'
import {
  CommonReasonTextarea,
  DatefilterFn,
  ValidateAPI,
  convertToLocalDate,
  handleAcceptExpediteDeferRequests,
  handlePODetailsClick,
  handleRejectExpediteDeferDivertRequest,
  reasonCodesEN,
  reasonCodesMN
} from '../../utils/Utils'
import ConfirmTable from '../../components/ConfirmTable'
import { LineComp } from './Expedite'
import Loading from '../../components/Loading'
import { EditedRowState } from '../../LineContext/Context'
import { useTranslation } from 'react-i18next'
import i18next from 'i18next'
import PopupModal from '../../components/PopupModal'
import PopupBanner from '../../components/PopupBanner'
import ReasonCodeList, { ReasonCodeView } from '../../components/ReasonCodeList'
import PopUpPastDue from '../../components/PopUpPastDue'
import { checkvalidpastDue } from '../../components/vendor/ExpediteActionComp'
import axiosInstance from '../../api/axiosInstance'
import { CartState } from '../../Context/Context'

const Defer = () => {
  const [requestData, setRequestData] = useState([])
  const user = JSON.parse(localStorage.getItem('userData'))
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const [selectedRowArray, setSelectedRowArray] = useState([])
  const [reasonCodeValue, setreasonCodeValue] = useState({
    "reasonCodeId": "",
    "reasonCodeText": ""
  })
  const [showRejectModal, setShowRejectModal] = useState(false)
  const [submitting, setSubmitting] = useState(false)
  const [rowSelection, setRowSelection] = useState({})
  const [showDeferAcceptModal, setShowDeferAcceptModal] = useState(false)
  const [showChangeRequestBanner, setShowChangeRequestBanner] = useState(false)
  const [showRejectRequestBanner, setShowRejectRequestBanner] = useState(false)
  const [showpastDueModel, setShowPastDueModel] = useState(false)
  const [editCrIdResponse, setEditCrIdResponse] = useState('')
  const [editPoRow, setEditPORow] = useState('')
  const [poRow, setPoRow] = useState('')
  const [crIdResponse, setCrIdResponse] = useState('')
  const { t } = useTranslation()
  const [validSw, setValidSw] = useState(false)
  const tableId = 'DeferTable'; // Define tableId here
  const { updateDataCount } = CartState()
  const [errorMessage, setErrorMessage] = useState('')

  const {
    DeferRequests,
    Home,
    Submitting_load,
    Pleaseselectreasoncodeforrejectingtheorder,
    Selectareason,
    PleaseselectaPO,
    ToProposeNewSWClickOnCR,
    NOTE,
    Reject,
    Cancel
  } = t('DeferPage')

  const {
    state: { editArray },
    dispatch
  } = EditedRowState()
  const headers = {
    CR: t('DeferPage.CR'),
    PONUMBER: t('DeferPage.PONUMBER'),
    SKU: t('DeferPage.SKU'),
    UPC: t('DeferPage.UPC'),
    // REQSW: t('DeferPage.REQSW'),
    CHANGEDSW: t('POList.CHANGEDSW'),
    CURRENTSW: t('DeferPage.CURRENTSW'),
    ORGSW: t('ConfirmPOpage.ORGSW'),
    STATUS: t('DeferPage.STATUS'),
    REQUESTTYPE: t('DeferPage.REQUESTTYPE'),
    REQUESTEDBY: t('DeferPage.REQUESTEDBY'),
    CREATEDATE: t('DeferPage.CREATEDATE'),
    UPDATEDATE: t('DeferPage.UPDATEDATE'),
    CRSTATUS: t('DeferPage.CRSTATUS'),
    VENDORRESPONSE: t('DeferPage.VENDORRESPONSE'),
    ONTIMETARGET: t('POList.ONTIMETARGET'),
    DELTA: t('ConfirmPOpage.DELTA')
  }

  // Access translated strings outside useMemo
  const columns = useMemo(
    () => [
      {
        header: headers.CR,
        accessorKey: 'id_open_request',
        cell: ({ row }) => (
          <p
            className='underline cursor-pointer text-blue-500'
            onClick={() =>
              navigate(
                `/vendor/po_change_requests/request_details/${row?.original.id_open_request}`,
                { state: row?.original }
              )
            }
          >
            {row?.original?.id_open_request}
          </p>
        ),
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        }
      },
      {
        header: headers.PONUMBER,
        accessorKey: 'po_number',
        cell: (info) => {
          return (
            <p
              className='underline cursor-pointer text-blue-500'
              onClick={() => handlePODetailsClick('vendor', info?.getValue())}
            >
              {info?.getValue()}
            </p>
          )
        },
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        }
      },
      {
        header: headers.SKU,
        accessorKey: 'sku',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        }
      },
      {
        header: headers.UPC,
        accessorKey: 'upc',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        }
      },
      {
        header: headers.CHANGEDSW,
        accessorKey: 'requested_ship_week',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        }
      },
      {
        header: headers.ORGSW,
        accessorKey: 'original_ship_week',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        }
      },
      {
        header: headers.CURRENTSW,
        accessorKey: 'current_ship_week',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        }
      },
      {
        header: headers.ONTIMETARGET,
        accessorKey: 'on_time_target',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        }
      },
      {
        header: headers.DELTA,
        accessorKey: 'ship_week_delay',
        filterFn: (row, id, value) => {
          const cellValue = row.getValue(id)

          // // Check if cellValue is null or undefined before calling toString()
          if (cellValue == null) {
            return false // or any other logic you want to apply when the value is null
          }
          let words = value.split(/[\s,]+/).map((word) => word.toLowerCase()) // Split by comma and spaces
          return words.includes(cellValue?.toLowerCase())
        }
      },
      {
        header: headers.VENDORRESPONSE,
        accessorFn: row => {
          const value = row?.supplier_response;

          if (value == null || String(value).trim() === '') {
            return 'BLANK';
          }

          return value.toUpperCase() === 'REJECTED'
            ? 'Acknowledged PO with exceptions'
            : value;
        },
        cell: ({ row }) => {
          const value = row?.original?.supplier_response;

          if (value == null || String(value).trim() === '') {
            return null;
          }

          return (
            <span>
              {value.toUpperCase() === 'REJECTED'
                ? 'Acknowledged PO with exceptions'
                : value}
            </span>
          );
        },

        filterFn: (row, id, filterValue) => {
          const cellValue = row.getValue(id);

          if (!cellValue || !filterValue) return false;

          const selectedValues = String(filterValue)
            .split(",")
            .map(value => value.trim().toLowerCase());

          return selectedValues.includes(
            String(cellValue).trim().toLowerCase()
          );
        }
      },
      {
        header: headers.CRSTATUS,
        accessorKey: 'status',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        }
      },
      {
        header: headers.REQUESTEDBY,
        accessorKey: 'created_by',
        filterFn: (row, id, value) => {
          return value.includes(row.getValue(id))
        }
      },
      {
        header: headers.CREATEDATE,
        accessorKey: 'created_at',
        cell: (info) =>
          info?.getValue() !== null ? convertToLocalDate(info?.getValue()) : '',
        filterFn: DatefilterFn
      },
      // {
      //   header: headers.UPDATEDATE,
      //   accessorKey: 'updated_at',
      //   cell: (info) =>
      //     info?.getValue() !== null ? formatDateFit(info?.getValue()) : ''
      // }
    ],
    [headers]
  )

  const closeDeferAcceptModal = () => {
    setShowDeferAcceptModal(false)
  }
  const checkpastDue = () => {
    return selectedRowArray?.some((c) => checkvalidpastDue(c?.requested_ship_week))
  }
  const openDeferAcceptModal = () => {
    if (checkpastDue())
      setShowPastDueModel(true)
    else
      setShowDeferAcceptModal(true)
  }

  const closePopUpModal = () => {
    // setPoRow(false)
    setShowRejectRequestBanner(false)
    setShowChangeRequestBanner(false)
  }

  const handleAcceptRequest = () => {
    setSubmitting(true)
    setShowRejectModal(true)
    handleAcceptExpediteDeferRequests(
      updateDataCount,
      setRequestData,
      selectedRowArray,
      setSubmitting,
      setShowRejectModal,
      (success, data) => {
        if (success) {
          if (data) {
            const crIdResponse = data.map((item) => item.id_open_request)
            const poRow = data.map((item) => item.po_number)
            setCrIdResponse(crIdResponse)
            setPoRow(poRow)
          }
          setShowChangeRequestBanner(true)
          fetchAllRequests()
          updateDataCount(user?.supplierId)
        }
      }
    )
    closeDeferAcceptModal()
  }
  useEffect(() => {
    const handleMessage = (event) => {
      if (event.data.updated) {
        fetchAllRequests(); // Refresh data when the popup sends an update
        updateDataCount(user?.supplierId)
      }
    };

    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  }, []);
  useEffect(() => {
    const handleClickOutside = () => {
      setShowChangeRequestBanner(false);
      setShowRejectRequestBanner(false);
    };
    if (showChangeRequestBanner || showRejectRequestBanner) {
      window.addEventListener('click', handleClickOutside);
    }
    return () => {
      window.removeEventListener('click', handleClickOutside);
    };
  }, [showChangeRequestBanner, showRejectRequestBanner]);

  const fetchAllRequests = () => {
    setLoading(true)
    axiosInstance
      .get(
        `/api/get-supplier-cr-type-data?vendorNumber=${user?.supplierId}&crType=DEFER`,
      )
      .then((response) => {
        if (response?.data?.[0]?.Message) return setRequestData([])
        setRequestData(response?.data)
        setLoading(false)
      })
      .catch((error) => {
        setLoading(false)
        console.error(error)
        if (error.response.status === 401 || error.response.status === 403) {
          navigate('/login-error')
        }
      })
  }



  useEffect(() => {
    fetchAllRequests()
    return () => {
      dispatch({
        type: 'CLEAR_LIST'
      })
    }
  }, [])

  useEffect(() => {
    if (selectedRowArray?.length > 0) {
      setValidSw(false); // Hide the error message as soon as an order is selected
    }
  }, [selectedRowArray]);

  const [additionalReasonForOther, setadditionalReasonForOther] = useState("")
  const changeOtherReason = (e) => {
    setadditionalReasonForOther(e.target.value)
    // setErrorMessage('');
  }

  return (
    <div className='w-full flex flex-col gap-6 justify-start items-start p-4'>
      <div className='w-full justify-between flex items-center'>
        <div className=''>
          <p className='text-xl'>{DeferRequests}</p>
        </div>
        {/* <UserProfile /> */}
      </div>
      <div className='w-full text-xs flex justify-start items-center gap-1 font-medium text-gray-600'>
        <p className='flex gap-1 items-center justify-center'>
          <span
            className='hover:underline cursor-pointer'
            onClick={() => navigate('/vendor')}
          >
            {Home}
          </span>
          <span>{'>'}</span>
        </p>
        <p className='flex gap-1 items-center justify-center'>
          <span>{DeferRequests}</span>
        </p>
      </div>


      <div>
        <div className='flex w-full justify-start items-center font-medium text-xs gap-3'>
          <button
            className='px-3 rounded-md bg-green-500 text-white h-[32px]'
            onClick={() => {
              if (selectedRowArray?.length > 0) {
                openDeferAcceptModal();
                setValidSw(false)
              } else {
                setValidSw(true)
              }
            }}

          >
            <span>
              {selectedRowArray?.length > 1 ? t('DeferPage.Accept') : t('DeferPage.Accept')}
            </span>
          </button>

          <PopupModal
            isOpen={showDeferAcceptModal}
            message={i18next.t('PopUpMessage.Doyouwanttoaccepttheserequests')}
            onCancel={closeDeferAcceptModal}
            cancelText={i18next.t('AcceptModal.Cancel')}
            onConfirm={handleAcceptRequest}
            confirmText={i18next.t('AcceptModal.Confirm')}
          />
          <PopUpPastDue
            isOpen={showpastDueModel}
            message={`Selected CR Is In Past Due, Can't Accept, but Can Reject`}
            onCancel={() => setShowPastDueModel(false)}
            cancelText={i18next.t('AcceptModal.Cancel')}
            onConfirm={() => { setShowRejectModal(true); setShowPastDueModel(false) }}
            confirmText={'Reject'}
            type={'reject'}
          />
          <button
            disabled={reasonCodeValue?.reasonCodeText === 'Other' && additionalReasonForOther.length === 0}
            className='px-3 rounded-md bg-red-500 text-white h-[32px]'
            onClick={() => {
              if (selectedRowArray?.length > 0) {
                setShowRejectModal(true);
                setValidSw(false)
              } else {
                setValidSw(true)
              }
            }}

          >
            {selectedRowArray?.length > 1 ? t('DeferPage.Reject') : t('DeferPage.Reject')}
          </button>
        </div>
        {validSw && (
          <p className='text-red-500 text-xs mt-2'>{PleaseselectaPO}</p>
        )}
      </div>
      <p className="text-yellow-600 text-sm italic my">
        <span className="font-bold text-black">{NOTE} : </span> {ToProposeNewSWClickOnCR}
      </p>

      {loading ? (
        <div className='w-full min-h-[300px] flex justify-center items-center'>
          <Loading />
        </div>
      ) : (
        <div className='w-full overflow-x-auto'>
          <ConfirmTable
            tableId={tableId}
            tableData={requestData}
            columns={columns}
            selection={setSelectedRowArray}
            updateRowSelectionProp={setRowSelection}
            rowSelectionProp={rowSelection}
          />
        </div>
      )}

      <dialog
        open={showRejectModal}
        className='p-3 inset-0 fixed z-70 bg-black bg-opacity-50 w-full min-h-screen'
      >
        <div className='w-full min-h-screen p-4 flex justify-center items-center'>
          {submitting ? (
            <div className='sm:w-[400px] w-[280px] bg-white p-4 rounded-md flex flex-col gap-6'>
              <Loading type={Submitting_load} />
            </div>
          ) : (
            <div className='sm:w-[400px] w-[280px] bg-white p-4 rounded-md flex flex-col gap-6'>
              <div className='w-full flex justify-end items-center'>
                <button
                  className='border-2 border-gray-300 p-2 rounded-md'
                  onClick={() => {
                    setShowRejectModal(false)
                    setreasonCodeValue({
                      "reasonCodeId": "",
                      "reasonCodeText": ""
                    })
                  }}
                >
                  ❌
                </button>
              </div>
              <div className='w-full flex justify-center items-center mt-2 text-center'>
                <p className='text-sm font-medium'>
                  {Pleaseselectreasoncodeforrejectingtheorder}
                </p>
              </div>
              {/* This is to show reasonCodeValue once user selected from list  */}
              <ReasonCodeView
                reasonCodeValue={reasonCodeValue}
                setreasonCodeValue={setreasonCodeValue} />
              {/* View End */}

              {/*  ReasonCode List Component to view all list and select*/}
              <ReasonCodeList
                reasonCodeValue={reasonCodeValue}
                setreasonCodeValue={setreasonCodeValue} 
                type='Defer' 
                setErrorMessage={setErrorMessage}
                setReasonMessage={setadditionalReasonForOther}
                />
              {reasonCodeValue?.reasonCodeText === "Others" && <div className="w-full flex flex-col">
                  <CommonReasonTextarea
                    value={additionalReasonForOther}
                    error={errorMessage}
                    onChange={changeOtherReason}
                    setErrorMessage={setErrorMessage}
                  />

                </div>}
              {/* End Component */}
              <div className='w-full flex justify-center items-center gap-4 mt-4'>
                  <button
                    className={`text-xs font-medium w-[80px] rounded-md h-[38px] text-white bg-red-500 outline-none ${errorMessage ? 'cursor-not-allowed opacity-50' : 'cursor-pointer'
                      }`} 
                      disabled={errorMessage}
                      onClick={() => {
                      if (reasonCodeValue?.reasonCodeText === "Others" && (!additionalReasonForOther || additionalReasonForOther.trim().length === 0)) {
                        setErrorMessage('Message is required');
                      } else {
                      handleRejectExpediteDeferDivertRequest(
                        additionalReasonForOther,
                        updateDataCount,
                        setRequestData,
                        selectedRowArray,
                        reasonCodeValue,
                        setShowRejectModal,
                        setreasonCodeValue,
                        setSubmitting,
                        (success, data) => {
                          if (success) {
                            if (data) {
                              const editCrIdResponse = data.map((item) => item.id_open_request);
                              const editPoRow = data.map((item) => item.po_number);
                              setEditPORow(editPoRow)
                              setEditCrIdResponse(editCrIdResponse);
                            }
                            setShowRejectRequestBanner(true);
                            fetchAllRequests()
                            updateDataCount(user?.supplierId);
                          }
                        }
                      )
                    }
                    }}
                  >
                    {Reject}
                  </button>
                <button
                  className='text-xs font-medium w-[80px] rounded-md h-[38px] text-white bg-gray-500 outline-none'
                  onClick={() => {
                    setShowRejectModal(false)
                    setreasonCodeValue({
                      "reasonCodeId": "",
                      "reasonCodeText": ""
                    })
                  }}
                >
                  {Cancel}
                </button>
              </div>
            </div>
          )}
        </div>
      </dialog>
      <PopupBanner
        isOpen={showChangeRequestBanner}
        message={" Defer Order Submitted Successfully"}
        onCancel={closePopUpModal}
        text={poRow}
        text1={crIdResponse}
      />
      <PopupBanner
        isOpen={showRejectRequestBanner}
        message={"Defer Requests Rejected  Successfully"}
        onCancel={closePopUpModal}
        text={editPoRow}
        text1={editCrIdResponse}
      />
    </div>
  )
}

export default Defer
